import { SelectOptionType, SizeType } from '@config/type'
import cn from 'classnames'
import { GroupBase, MenuProps } from 'react-select'

import { SelectItemMarker } from '@components/select/select-item-marker/select-item-marker'

import styles from './select-list-marker.module.css'

export const SelectListMarker = ({
  options,
  selectOption,
  selectProps,
  sizeType,
  fontType,
  styleType,
  borderType
}: MenuProps<
  SelectOptionType<string>,
  true,
  GroupBase<SelectOptionType<string>>
> & {
  sizeType?: SizeType
  fontType?: SizeType
  styleType?: 'primary' | 'secondary' | 'inverse' | 'transparent' | 'danger'
  borderType?: 'primary' | 'secondary' | 'none' | 'danger' | 'inverse'
}) => {
  const handleClick = (option: SelectOptionType<string>) => {
    selectOption(option)
  }
  const selectedValues = selectProps.value as SelectOptionType<string>[]
  const selectOptionsObject = selectedValues
    ? selectedValues.reduce<SelectOptionType<string>>(
        (prev, current) => ({
          ...prev,
          [current.value]: {
            ...current
          }
        }),
        {} as SelectOptionType<string>
      )
    : {}

  return (
    <div
      className={cn(styles.container, {
        [styles.primary]: styleType === 'primary',
        [styles.secondary]: styleType === 'secondary',
        [styles.transparent]: styleType === 'transparent',
        [styles.inverse]: styleType === 'inverse',
        [styles.borderNone]: borderType === 'none',
        [styles.borderPrimary]: borderType === 'primary',
        [styles.borderSecondary]:
          borderType === 'secondary' && styleType !== 'primary',
        [styles.borderInverse]:
          borderType === 'inverse' && styleType !== 'primary',
        [styles.borderDanger]:
          borderType === 'danger' || styleType === 'danger',
        [styles.danger]: styleType === 'danger'
      })}
    >
      <div className={styles.list}>
        {(options as SelectOptionType<string>[]).map(
          (option: SelectOptionType<string>) => (
            <SelectItemMarker
              key={option.value}
              // isActive={selectOptionsObject[option.value]}
              isActive={option.value in selectOptionsObject}
              value={option.label}
              onClick={() => handleClick(option)}
              sizeType={sizeType}
              fontType={fontType}
              styleType={styleType}
            />
          )
        )}
      </div>
    </div>
  )
}
